"use strict";

theme.buildCollectionItem = function (items) {
  var output = "";

  items.forEach((collection) => {
    var markup = `
      <li>
        <a href="${collection.url}">
          ${collection.title}
        </a>
      </li>
    `;

    output += markup;
  });

  return output;
};

theme.Collection = (function () {
  var isAnimating = false;

  var selectors = {
    sortSelect: "#SortBy",

    colorSwatchImage: ".grid-product__color-image",
    colorSwatch: ".color-swatch--with-image",

    collectionGrid: ".collection-grid__wrapper",
    trigger: ".collapsible-trigger",
    sidebar: "#CollectionSidebar",
    filterSidebar: ".collapsible-content--sidebar",
    activeTagList: ".tag-list--active-tags",
    tags: ".tag-list input",
    activeTags: ".tag-list a",
    tagsForm: ".filter-form",
    filters: ".collection-filter",
    priceRange: ".price-range",
  };

  var classes = {
    activeTag: "tag--active",
    removeTagParent: "tag--remove",
    filterSidebar: "collapsible-content--sidebar",
    isOpen: "is-open",
  };

  function Collection(container) {
    this.container = container;
    this.sectionId = container.getAttribute("data-section-id");
    this.namespace = ".collection-" + this.sectionId;
    this.sidebar = new theme.CollectionSidebar(container);
    this.ajaxRenderer = new theme.AjaxRenderer({
      sections: [
        {
          sectionId: this.sectionId,
          nodeId: "CollectionAjaxContent",
        },
      ],
      onReplace: this.onReplaceAjaxContent.bind(this),
    });

    this.init();
  }

  Collection.prototype = Object.assign({}, Collection.prototype, {
    init: function () {
      this.initSort();
      this.colorSwatchHovering();
      this.initFilters();
      this.initPriceRange();
      this.sidebar.init();
    },

    initSort: function () {
      this.sortSelect = document.querySelector(selectors.sortSelect);

      if (this.sortSelect) {
        this.defaultSort = this.getDefaultSortValue();
        this.sortSelect.on(
          "change" + this.namespace,
          this.onSortChange.bind(this),
        );
      }
    },

    getSortValue: function () {
      return this.sortSelect.value || this.defaultSort;
    },

    getDefaultSortValue: function () {
      return this.sortSelect.getAttribute("data-default-sortby");
    },

    onSortChange: function () {
      this.queryParams = new URLSearchParams(window.location.search);

      this.queryParams.set("sort_by", this.getSortValue());
      this.queryParams.delete("page"); // Delete if it exists

      window.location.search = this.queryParams.toString();
    },

    colorSwatchHovering: function () {
      var colorImages = this.container.querySelectorAll(
        selectors.colorSwatchImage,
      );
      if (!colorImages.length) {
        return;
      }

      this.container
        .querySelectorAll(selectors.colorSwatch)
        .forEach((swatch) => {
          swatch.addEventListener("mouseenter", function () {
            var id = swatch.dataset.variantId;
            var image = swatch.dataset.variantImage;
            var el = document.querySelector(
              ".grid-product__color-image--" + id,
            );
            el.style.backgroundImage = "url(" + image + ")";
            el.classList.add("is-active");
          });
          swatch.addEventListener("mouseleave", function () {
            var id = swatch.dataset.variantId;
            document
              .querySelector(".grid-product__color-image--" + id)
              .classList.remove("is-active");
          });
        });
    },

    /*====================
      Collection filters
    ====================*/
    initFilters: function () {
      var tags = document.querySelectorAll(selectors.tags);

      if (!tags.length) {
        return;
      }

      this.bindBackButton();

      // Set mobile top value for filters if sticky header enabled
      if (theme.config.stickyHeader) {
        this.setFilterStickyPosition();

        window.on(
          "resize",
          theme.utils.debounce(500, this.setFilterStickyPosition),
        );
      }

      document.querySelectorAll(selectors.activeTags).forEach((tag) => {
        tag.addEventListener("click", this.tagClick.bind(this));
      });

      document.querySelectorAll(selectors.tagsForm).forEach((form) => {
        form.addEventListener("input", this.onFormSubmit.bind(this));
      });
    },

    initPriceRange: function () {
      const priceRangeEls = document.querySelectorAll(selectors.priceRange);
      priceRangeEls.forEach(
        (el) =>
          new theme.PriceRange(el, {
            // onChange passes in formData
            onChange: this.renderFromFormData.bind(this),
          }),
      );
    },

    tagClick: function (evt) {
      var el = evt.currentTarget;

      if (theme.FilterDrawer) {
        theme.FilterDrawer.close();
      }

      // Do not ajax-load collection links
      if (el.classList.contains("no-ajax")) {
        return;
      }

      evt.preventDefault();

      if (isAnimating) {
        return;
      }

      isAnimating = true;

      const parent = el.parentNode;
      const newUrl = new URL(el.href);

      this.renderActiveTag(parent, el);
      this.updateScroll(true);
      this.startLoading();
      this.renderCollectionPage(newUrl.searchParams);
    },

    onFormSubmit: function (evt) {
      var el = evt.target;

      if (theme.FilterDrawer) {
        theme.FilterDrawer.close();
      }

      // Do not ajax-load collection links
      if (el.classList.contains("no-ajax")) {
        return;
      }

      evt.preventDefault();
      if (isAnimating) {
        return;
      }

      isAnimating = true;

      const parent = el.closest("li");
      const formEl = el.closest("form");
      const formData = new FormData(formEl);

      this.renderActiveTag(parent, el);
      this.updateScroll(true);
      this.startLoading();
      this.renderFromFormData(formData);
    },

    fetchOpenCollasibleFilters: function () {
      return Array.from(
        document.querySelectorAll(
          `${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`,
        ),
      ).map((trigger) => trigger.dataset.collapsibleId);
    },

    renderActiveTag: function (parent, el) {
      const textEl = parent.querySelector(".tag__text");

      if (parent.classList.contains(classes.activeTag)) {
        parent.classList.remove(classes.activeTag);
      } else {
        parent.classList.add(classes.activeTag);

        // If adding a tag, show new tag right away.
        // Otherwise, remove it before ajax finishes
        if (el.closest("li").classList.contains(classes.removeTagParent)) {
          parent.remove();
        } else {
          // Append new tag in both drawer and sidebar
          document
            .querySelectorAll(selectors.activeTagList)
            .forEach((list) => {
              const newTag = document.createElement("li");
              const newTagLink = document.createElement("a");
              newTag.classList.add("tag", "tag--remove");
              newTagLink.classList.add("btn", "btn--small");
              newTagLink.innerText = textEl.innerText;
              newTag.appendChild(newTagLink);

              list.appendChild(newTag);
            });
        }
      }
    },

    renderFromFormData: function (formData) {
      const searchParams = new URLSearchParams(formData);
      this.renderCollectionPage(searchParams);
    },

    onReplaceAjaxContent: function (newDom, section) {
      const openCollapsibleIds = this.fetchOpenCollasibleFilters();

      openCollapsibleIds.forEach((selector) => {
        newDom
          .querySelectorAll(`[data-collapsible-id=${selector}]`)
          .forEach(this.openCollapsible);
      });

      var newContentEl = newDom.getElementById(section.nodeId);
      if (!newContentEl) {
        return;
      }

      document.getElementById(section.nodeId).innerHTML =
        newContentEl.innerHTML;
    },

    openCollapsible: function (el) {
      if (el.classList.contains(classes.filterSidebar)) {
        el.style.height = "auto";
      }

      el.classList.add(classes.isOpen);
    },

    renderCollectionPage: function (searchParams, updateURLHash = true) {
      this.ajaxRenderer
        .renderPage(window.location.pathname, searchParams, updateURLHash)
        .then(() => {
          theme.sections.reinit("collection-grid");
          this.updateScroll(false);
          this.initPriceRange();
          theme.reinitProductGridItem();

          document.dispatchEvent(new CustomEvent("collection:reloaded"));

          isAnimating = false;
        });
    },

    bindBackButton: function () {
      // Ajax page on back button
      window.off("popstate" + this.namespace);
      window.on(
        "popstate" + this.namespace,
        function (state) {
          if (state) {
            const newUrl = new URL(window.location.href);
            this.renderCollectionPage(newUrl.searchParams, false);
          }
        }.bind(this),
      );
    },

    updateScroll: function (animate) {
      var scrollToElement = document.querySelector("[data-scroll-to]");
      var scrollTo = scrollToElement && scrollToElement.offsetTop;

      if (!theme.config.bpSmall) {
        scrollTo -= 15;
      }

      if (theme.config.stickyHeader) {
        var headerHeight =
          document.querySelector(".site-header").offsetHeight;
        scrollTo = scrollTo - headerHeight;
      }

      if (animate) {
        window.scrollTo({ top: scrollTo, behavior: "smooth" });
      } else {
        window.scrollTo({ top: scrollTo });
      }
    },

    setFilterStickyPosition: function () {
      var headerHeight = document.querySelector(".site-header").offsetHeight;
      document.querySelector(selectors.filters).style.top =
        headerHeight + 10 + "px";

      // Also update top position of sticky sidebar
      var stickySidebar = document.querySelector(".grid__item--sidebar");
      if (stickySidebar) {
        stickySidebar.style.top = headerHeight + 10 + "px";
      }
    },

    forceReload: function () {
      this.init();
    },

    startLoading: function () {
      document
        .querySelector(selectors.collectionGrid)
        .classList.add("unload");
    },
  });

  return Collection;
})();

theme.CollectionHeader = (function () {
  var hasLoadedBefore = false;

  function CollectionHeader(container) {
    this.namespace = ".collection-header";

    var heroImageContainer = container.querySelector(".collection-hero");
    if (heroImageContainer) {
      if (hasLoadedBefore) {
        this.checkIfNeedReload();
      }
      theme.loadImageSection(heroImageContainer);

      if (container.dataset && container.dataset.parallax) {
        var parallaxContainer = container.querySelector(
          ".parallax-container",
        );
        var args = {
          namespace: this.namespace + "-parallax",
        };
        theme.parallaxSections[this.namespace] = new theme.Parallax(
          parallaxContainer,
          args,
        );
      }
    } else if (theme.settings.overlayHeader) {
      theme.headerNav.disableOverlayHeader();
    }

    hasLoadedBefore = true;
  }

  CollectionHeader.prototype = Object.assign({}, CollectionHeader.prototype, {
    // A liquid variable in the header needs a full page refresh
    // if the collection header hero image setting is enabled
    // and the header is set to sticky. Only necessary in the editor.
    checkIfNeedReload: function () {
      if (!Shopify.designMode) {
        return;
      }

      if (theme.settings.overlayHeader) {
        var header = document.querySelector(".header-wrapper");
        if (!header.classList.contains("header-wrapper--overlay")) {
          location.reload();
        }
      }
    },

    onUnload: function () {
      if (theme.parallaxSections[this.namespace]) {
        theme.parallaxSections[this.namespace].destroy();
        delete theme.parallaxSections[this.namespace];
      }
    },
  });

  return CollectionHeader;
})();

theme.CollectionSidebar = (function () {
  var drawerStyle = false;
  var selectors = {
    sidebar: "#CollectionSidebar",
  };

  function CollectionSidebar(container) {
    this.container = container.querySelector(selectors.sidebar);
  }

  CollectionSidebar.prototype = Object.assign(
    {},
    CollectionSidebar.prototype,
    {
      init: function () {
        // Do not load when no sidebar exists
        if (!this.container) {
          return;
        }

        this.onUnload();

        drawerStyle = this.container.dataset.style === "drawer";
        theme.FilterDrawer = new theme.Drawers(
          "FilterDrawer",
          "collection-filters",
          true,
        );
      },

      forceReload: function () {
        this.init();
      },

      onSelect: function () {
        if (theme.FilterDrawer) {
          if (!drawerStyle) {
            theme.FilterDrawer.close();
            return;
          }

          if (drawerStyle || theme.config.bpSmall) {
            theme.FilterDrawer.open();
          }
        }
      },

      onDeselect: function () {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      },

      onUnload: function () {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      },
    },
  );

  return CollectionSidebar;
})();

theme.Blog = (function () {
  function Blog(container) {
    this.tagFilters();
  }

  Blog.prototype = Object.assign({}, Blog.prototype, {
    tagFilters: function () {
      var filterBy = document.getElementById("BlogTagFilter");

      if (!filterBy) {
        return;
      }

      filterBy.addEventListener("change", function () {
        location.href = filterBy.value;
      });
    },
  });

  return Blog;
})();

